/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Reject_Dialog_TitleInputs */

const en_samples_reject_dialog_title = /** @type {(inputs: Samples_Reject_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject Selected Samples`)
};

const es_samples_reject_dialog_title = /** @type {(inputs: Samples_Reject_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar muestras seleccionadas`)
};

/**
* | output |
* | --- |
* | "Reject Selected Samples" |
*
* @param {Samples_Reject_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_reject_dialog_title = /** @type {((inputs?: Samples_Reject_Dialog_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Reject_Dialog_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_reject_dialog_title(inputs)
	return es_samples_reject_dialog_title(inputs)
});